import React from 'react'
import content from './dropdown-content'
import { Link }                 from "react-router-dom";

const Dropdown = props => {
    return (
        <div className={`open-dropdown${props.open ? ' open' : ''}`}>
         {
             content && props.itemName && content[props.itemName] && content[props.itemName].map(((c, id) => (
                <Link to={`${c.slug}`} key={id}>
                    <i className="fas fa-angle-right" />
                    <span>{ c.label }</span>
                </Link>
             )))
         }   
        </div>
    )
}

export default Dropdown
